module.exports = __webpack_public_path__ + "static/media/place-24px - red.2268469a.svg";